import Select from "@/components/Select";
import { useTranslation } from "@/i18n/client";
import { useContext } from "react";
import { EnumerationsContext } from "@/contexts/EnumerationsContext";
import { getMappedEnumToSelect } from "@/screens/common/Degree/helpers";
import { SelectProps } from "@mantine/core";

export const DegreeBeforeName = (props: SelectProps) => {
  const enums = useContext(EnumerationsContext);
  const { t } = useTranslation("customer");
  const empty = [{ value: "", label: "Bez titulu" }];

  return (
    <Select
      searchable
      label={t("degreeBefore")}
      data={empty.concat(getMappedEnumToSelect(enums.degreeBefores))}
      allowDeselect
      pii
      {...props}
    />
  );
};
